import script from "./AssociationView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AssociationView.vue?vue&type=script&lang=ts&setup=true"

import "./AssociationView.vue?vue&type=style&index=0&id=ed6f7928&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed6f7928"]])

export default __exports__